<template>
  <!-- 订单管理页面根容器 -->
  <div>
    <!-- 页面标题 -->
    <h3 style="margin-bottom:20px">订单管理</h3>

    <!--
      订单搜索输入框
      v-model 双向绑定搜索关键词
      根据订单编号模糊搜索
    -->
    <el-input
      v-model="searchKey"
      placeholder="搜索订单号"
      style="width:250px;margin-bottom:15px"
    />

    <!--
      订单数据表格
      :data 绑定表格数据
      border 显示表格边框
      @row-dblclick 双击行查看订单详情
    -->
    <el-table
      :data="showList"
      border
      @row-dblclick="showOrderDetail"
    >
      <!-- 订单ID列 -->
      <el-table-column prop="id" label="订单ID" />

      <!-- 订单编号列 -->
      <el-table-column prop="no" label="订单编号" />

      <!-- 支付金额列 -->
      <el-table-column prop="money" label="支付金额" />

      <!-- 订单状态列 -->
      <el-table-column prop="status" label="订单状态" />
    </el-table>

    <!--
      订单详情弹窗
      双击表格行打开
      :visible.sync 控制弹窗显示隐藏
    -->
    <el-dialog
      title="订单详情"
      :visible.sync="detailVisible"
      :close-on-click-modal="false"
    >
      <!-- 订单详情表单，禁用状态，仅用于查看 -->
      <el-form :model="currentOrder" label-width="80px" disabled>
        <el-form-item label="订单ID">
          <span>{{ currentOrder.id }}</span>
        </el-form-item>

        <el-form-item label="订单号">
          <span>{{ currentOrder.no }}</span>
        </el-form-item>

        <el-form-item label="金额">
          <span>¥ {{ currentOrder.money }}</span>
        </el-form-item>

        <el-form-item label="状态">
          <span>{{ currentOrder.status }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // 页面响应式数据定义
  data() {
    return {
      searchKey: "",        // 搜索关键词
      orderList: [],        // 订单列表原始数据
      detailVisible: false, // 控制详情弹窗显示/隐藏
      currentOrder: {}      // 当前查看的订单对象
    };
  },

  // 计算属性：根据搜索关键词过滤订单列表
  computed: {
    showList() {
      // 无搜索内容时，显示全部订单
      if (!this.searchKey) {
        return this.orderList;
      }
      // 有搜索内容时，根据订单号模糊搜索
      return this.orderList.filter((item) =>
        item.no.includes(this.searchKey)
      );
    }
  },

  // 页面挂载完成后自动获取订单列表
  async mounted() {
    const { data } = await this.$axios.get("/api/order/list");
    this.orderList = data.data;
  },

  // 页面方法集合
  methods: {
    // 显示订单详情弹窗
    showOrderDetail(row) {
      // 将当前行数据赋值给详情对象
      this.currentOrder = row;
      // 打开弹窗
      this.detailVisible = true;
    }
  }
};
</script>